import { EMRdetailsProps, IEMRUpdatePayloadProps } from "@/api_framework/api_modals/EMRs";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { useEffect, useState } from "react";
import SkinLesionComponent from "../SkinLesionComponent";

const apperence = ["BAR : Bright, Alert and Responsive", "Dull and Depressed"];
const appetite = ["Normal", "Inappetance", "Anorexia"];
const circulation = ["Pink & Moist", "Pale Pink", "Blanched", "Congested"];
const lymphNode = ["NAD", "Enlarged"];

type SectionType = "general_appearance" | "appetite" | "cmm" | "lymph_nodes";

const GeneralAppearanceComponent = ({ emrDetails, setEmrDetails, errorMessage, setErrorMessage }: EMRdetailsProps) => {
  const [selectedApperence, setSelectedApperence] = useState<string>(null);
  const [selectappetite, setSelectappetite] = useState<string>(null);
  const [selectcirculation, setSelectcirculation] = useState<string>(null);
  const [selectedLymphNode, setSelectedLymphNode] = useState<string>(null);

  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();

  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");

  const updateEmrDetails = (value: string, section: SectionType) => {
    const constructedBody: IEMRUpdatePayloadProps = {
      [section]: value,
      emr_status: emrDetails?.emr_status,
    };

    updateEmrAPI(emr_id, constructedBody);
  };

  const handleUpdate = (value: string, section: SectionType) => {
    const uiState: Record<SectionType, (val: string) => void> = {
      general_appearance: setSelectedApperence,
      appetite: setSelectappetite,
      cmm: setSelectcirculation,
      lymph_nodes: setSelectedLymphNode,
    };
    uiState[section](value);
    updateEmrDetails(value, section);

    setErrorMessage((prev: string[] | null) => {
      if (!prev) return prev;

      const fieldLabels: Record<SectionType, string> = {
        general_appearance: "General Appearance",
        appetite: "Appetite",
        cmm: "CMM",
        lymph_nodes: "Lymph Nodes",
      };

      const label = fieldLabels[section];

      return prev.filter((msg) => msg !== label);
    });
  };

  useEffect(() => {
    if (emrDetails) {
      setSelectedApperence(emrDetails?.general_appearance);
      setSelectappetite(emrDetails?.appetite);
      setSelectcirculation(emrDetails?.cmm);
      setSelectedLymphNode(emrDetails?.lymph_nodes);
    }
  }, [emrDetails]);

  return (
    <div className="bg-white">
      <div className="bg-[#F9FAFB] rounded-xl p-2">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42">
          General Appearance{" "}
          {errorMessage?.includes("General Appearance") && (
            <span className="text-red-500 pl-4 text-xs">Pick one option to finish EMR</span>
          )}
        </h3>
        <div className="flex gap-3 flex-wrap font-medium bg-white p-2 mt-1 rounded-lg">
          {apperence?.map((item, id) => {
            return (
              <button
                className={`${selectedApperence === item ? "text-[#000000] border-[#000000]" : "text-[#6C727F]  border-[#E2E2E2]"} border rounded-lg p-[10px] text-sm w-40`}
                key={id}
                onClick={() => handleUpdate(item, "general_appearance")}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      <div className="bg-[#F9FAFB] rounded-xl p-2 mt-2">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42">
          Appetite
          {errorMessage?.includes("Appetite") && (
            <span className="text-red-500 pl-4 text-xs">Pick one option to finish EMR</span>
          )}
        </h3>
        <div className="flex gap-3 flex-wrap font-medium bg-white p-2 mt-1 rounded-lg">
          {appetite?.map((item, id) => {
            return (
              <button
                className={`${selectappetite === item ? "text-[#000000] border-[#000000]" : "text-[#6C727F]  border-[#E2E2E2]"} border rounded-lg p-[10px] text-sm w-40`}
                key={id}
                onClick={() => handleUpdate(item, "appetite")}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>
      <div className="bg-[#F9FAFB] rounded-xl p-2 mt-2">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42">
          CMM
          {errorMessage?.includes("CMM") && (
            <span className="text-red-500 pl-4 text-xs">Pick one option to finish EMR</span>
          )}
        </h3>
        <div className="flex gap-3 flex-wrap font-medium bg-white p-2 mt-1 rounded-lg">
          {circulation?.map((item, id) => {
            return (
              <button
                className={`${selectcirculation === item ? "text-[#000000] border-[#000000]" : "text-[#6C727F]  border-[#E2E2E2]"} border rounded-lg p-[10px] text-sm w-40`}
                key={id}
                onClick={() => handleUpdate(item, "cmm")}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      <div className="bg-[#F9FAFB] rounded-xl p-2 mt-2">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42">
          Lymph Nodes
          {errorMessage?.includes("Lymph Nodes") && (
            <span className="text-red-500 pl-4 text-xs">Pick one option to finish EMR</span>
          )}
        </h3>
        <div className="flex gap-3 flex-wrap font-medium bg-white p-2 mt-1 rounded-lg">
          {lymphNode?.map((item, id) => {
            return (
              <button
                className={`${selectedLymphNode === item ? "text-[#000000] border-[#000000]" : "text-[#6C727F]  border-[#E2E2E2]"} border rounded-lg p-[10px] text-sm w-40`}
                key={id}
                onClick={() => handleUpdate(item, "lymph_nodes")}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      <SkinLesionComponent emrDetails={emrDetails} setEmrDetails={setEmrDetails} />
    </div>
  );
};
export default GeneralAppearanceComponent;
